/**
 * ========================================================
 * Description: Component to render the Home dashboard,
 *              also see .dashboard, which mirrors much
 *              of the same functionality.
 * Creation Date: ?
 * Author: ?
 * ========================================================
 * Revision History
 * ========================================================
 * Rev     Date        Author               Task        Description
 * ========================================================
 * 1	02/10/16    Vasil Galinovsky	                Errors cannot be "Closed"
 * 2	02/10/16	Vasil Galinovsky	                Graph Titles Do Not Appear
 * 3    03/08/16    AMcDaniel               82959271    Removed R_loc and created a folder to put new translations files in for client-side developers
 * 4    03/29/16    Sebastian Mansfield                 Made charts clickable
 * 5    03/29/16    andrew.gay              85657214    Functionality to populate the dashboard part aggregation data as the page loads
 * 6    03/30/16    andrew.gay              85657214    Modified code the not improperly disorder the grid which may have fixed the hanging issue
 * 7    03/30/16    andrew.gay              85657214    Temp fix for dashboard parts not saving position
 * 8    04/01/16    andrew.gay              85657214    Moved set state for adding dashboard components to ensure it runs on the last iteration
 * 9    05/09/16    Victor Hernandez                    Deleting local storage so that layout changes get saved properly.
 * 10   05/12/16    Adam McDaniel           91072841    Fixed some scoping issues related to individual dashboard part requests
 * 10   05/12/16    Adam McDaniel           91072841    Fixed some scoping issues related to individual dashboard part requests
 * 11   06/09/16    Adam McDaniel           95984485    Changed dashboard_parts to use .code instead of ._id
 * 12   06/15/16    andrew.gay              96815349    Appending component.div_id to unique id on ranked_list and tile
 * 13   06/23/16    Adam McDaniel           Bug         Added code to escape some characters in unique_id that could be causing a crash
 * 14   06/27/16    Victor Hernandez        97644865    Added multi-bar chart functionality.
 * 15   06/27/16    AMcDaniel               97216497    Added ability to redirect home app_object to another app_object
 * 16   06/27/16    Mcasanova               98464947    Clicking the first row in a ranked list should only run the conditions, changing regex validation and adding a new unique condition by the iterative var, now dosent retur equals values
 * 17   07/12/16    Victor Hernandez                    Implemented multi-line/bars graphs.
 * 18   07/29/16    andrew.gay              103614531   to_locale_string option to convert string into int into proper currency cammas.
 * 19   07/29/16    andrew.gay              103712251   Changed from to_locale_string to format_label, half running through dev extreme. Would like to run without dev dextreme
 * 20   07/29/16    andrew.gay              103191750   Removed code the prevent single bar from being selected
 * 21   07/29/16    andrew.gay              BUG         Fixed bug with weird values on bar charts for tractfile
 * 22   08/01/16    Sebastian Mansfield                 Made tile prevent clicking while dragging
 * 23   08/11/16    Sebastian Mansfield                 Added vector map dashboard map
 * 24   08/29/16    Victor Hernandez        96206960    Vector maps now apply conditions on click.
 * 25   09/09/16    AMcDaniel               109177071   Replaced makeid logic with general_utils create_guid and create_uid
 * 26   09/12/16    Victor Hernandez        109042864   Added defaulting to bar_charts condition field.
 * 27   09/20/16    AMcDaniel               111601259   Added descriptions for tile dashboard parts
 * 28   02/20/17    AMcDaniel               111619571   Added the following things to enable the custom dashboard parts for LR: caption_options to chart titles, added_drilldown_conditions to dashboard series (along with some fields which are passed directly to dxChart) and custom_properties.visualization_sub_type, custom_properties.valueAxis, custom_properties.rotated
 * 29   02/22/17    AMcDaniel               111619571   Refactored to make the refresh graph logic more straightforward and universal.  Added display_empty_graph option to allow dropdowns on new dashboard parts to be functional when the initial request pulls no data.
 * 30   03/06/17    AMcDaniel               111619571   Changed logic for when caption_option.input_type == "month" to allow for null or empty values
 * ========================================================
 **/
var HomeDashboardComponent = React.createClass({
    getInitialState: function () {
        this.initialize_dashboard();
        return {components: {}};
    },
    on_error_close: function() {
        this.setState({error:undefined});
    },
    get_component_by_div_id: function (div_id) {
        for (var key in this.state.components) {
            var component = this.state.components[key];
            if (component.div_id && component.div_id == div_id) {
                return component;
            }
        }
    },
    get_dashboard_part_loc: function (dashboard_part_id) {
        for (var i = 0; i < this.state.home_layout.length; i++) {
            var home_layout = this.state.home_layout[i];
            if (home_layout.dashboard_part_id == dashboard_part_id) {
                return home_layout;
            }
        }
    },
    add_single_caption_option: function(local_component, local_index, caption_option, parent_jquery_element) {
        var context = this;
        var option_onchange_function = function (e) {
            local_component.dashboard_part.options_data[local_index] = e.target.value;
            context.refresh_dashboard_part_data_with_options(local_component);
        };
        if(caption_option.input_type == "select") {
            var select_string = "<select>";
            for (var i = 0; i < caption_option.select_data.length; i++) {
                select_string = select_string + '<option value="' + caption_option.select_data[i].code + '"' + ((caption_option.select_data[i].selected) ? 'selected="selected"' : '') + '>' + caption_option.select_data[i].value + '</option>';
            }
            select_string = select_string + "</select>";
            if(!caption_option.label || (caption_option.label == "")) {
                parent_jquery_element.append("<span>" + select_string + "</span>");
            }
            else {
                parent_jquery_element.append("<span>" + caption_option.label + "&nbsp;" + select_string + "</span>");
            }

            var new_jquery_select_element = parent_jquery_element.select("select").last();
            new_jquery_select_element.on("change", option_onchange_function);
        }
        else if (caption_option.input_type) {
            if(!caption_option.label || (caption_option.label == "")) {
                parent_jquery_element.append('<span><input type="' + caption_option.input_type + '"></span>');
            }
            else {
                parent_jquery_element.append('<span>' + caption_option.label + '&nbsp;<input type="' + caption_option.input_type + '"></span>');
            }

            if (caption_option.input_type == "month") {  //will need to do this validation for date too
                var old_onchange_function = option_onchange_function;
                option_onchange_function = function(e) {
                    if(!e.target.value || (e.target.value == "")) {
                        e.target.value = null;
                    }
                    if(!e.target.value || is_valid_month_input(e.target.value)) {
                        old_onchange_function(e);
                    }
                };
            }

            var new_jquery_calendar_element = parent_jquery_element.select(caption_option.input_type).last();
            new_jquery_calendar_element.on("change", option_onchange_function);
        }
    },
    set_dashboard_item_title: function (jqueryElement, title, component, description) {
        title = title || "";
        jqueryElement.html(title);
        if((description && description != "") || (component.dashboard_part.custom_properties.caption_options && component.dashboard_part.custom_properties.caption_options.length)) {
            var parent_jquery_element = jqueryElement.parent();
            if(description && description != "") {
                parent_jquery_element.append("<div>" + description + "</div>");
            }
            if (component.dashboard_part.custom_properties.caption_options && component.dashboard_part.custom_properties.caption_options.length) {
                component.dashboard_part.options_data = component.dashboard_part.options_data || component.dashboard_part.custom_properties.caption_options.map(function (a) {
                        return a.default_value;
                    });
                for(var i = 0; i < component.dashboard_part.custom_properties.caption_options.length; i++) {
                    var new_jquery_element = $((component.dashboard_part.custom_properties.caption_options[i] && component.dashboard_part.custom_properties.caption_options[i].use_div) ? "<div/>" : "<span/>");
                    this.add_single_caption_option(component, i, component.dashboard_part.custom_properties.caption_options[i], new_jquery_element);
                    parent_jquery_element.append(new_jquery_element);
                }
            }
        }
        var context = this;
        if (component.dashboard_part.linked_app_object_code) {
            jqueryElement.attr("href", "");
            jqueryElement.on("click", function (event) {
                event.preventDefault();
                var app_object = {};
                app_object.type = "data_list";
                app_object.code = component.dashboard_part.linked_app_object_code;
                if(component.dashboard_part.visualization_type == "tile")
                {
                    app_object.conditions = component.dashboard_part.aggregation_data[0].conditions;
                }
                return context.props.app_object_handler(app_object);
            });
        }
    },
    fix_visual_control_size: function (jquery_element, jquery_element_title, visual_control) {
        jquery_element.height(jquery_element.parent().height() - jquery_element_title.parent().outerHeight(true));
        visual_control.option({
            size: {
                heigth: jquery_element.height(),
                width: jquery_element_title.parent().width()
            }
        });
        visual_control.render();
    },
    componentDidMount: function(){
        $(window).on('resize', this.on_resize);
    },
    componentWillUnmount: function (){
        $(window).off('resize');
    },
    on_resize: function(event){
        var maxFontSize = 150000000000, minFontSize = 50, parentWidthPercentage = 1, parentHeightPercentage=0.6, parentHeight, parentWidth;

        var context = this;
        if (!this.resizing){
            //Tile font size
            this.resizing = true;
            var element, e,parent;
            if (window instanceof event.target.constructor || event.target.constructor.name == "Window"){
                element = $('.dashboard-part-tile-body');
                element.each(function(){
                    e = $(this);
                    parent = $(e.parents()[5]);
                    parentHeight = parent.height() - $(parent.find('.dashboard-part-title')[0]).height();
                    parentWidth = parent.width();
                    e.css('font-size', Math.floor(Math.min(Math.max(Math.min(parentHeight*parentHeightPercentage,parentWidth*parentWidthPercentage/e.text().length),minFontSize),maxFontSize)) + "px");
                });

                //chart resizing
                element = $('.dxc');
                element.each(function(){
                    var dx_id = $(this).parent()[0].id;
                    if (dx_id) {
                        var component = context.get_component_by_div_id(dx_id);
                        if (component && component.visual_control && component.visual_control.render) {
                            context.fix_visual_control_size($('#' + dx_id), $('#' + dx_id + '-title'), component.visual_control);
                        }
                    }
                });
            } else {
                e = $(event.target).find('.dashboard-part-tile-body');
                if (e.length){
                    parent = $(event.target);
                    parentHeight = parent.height() - $(parent.find('.dashboard-part-title')[0]).height();
                    parentWidth = parent.width();
                    e.css('font-size', Math.floor(Math.min(Math.max(Math.min(parentHeight*parentHeightPercentage,parentWidth*parentWidthPercentage/e.text().length),minFontSize),maxFontSize)) + "px");
                } else {
                    e = $(event.target).find('.dxc');
                    if (e.length){
                        var dx_id = $(e[0]).parents()[0].id;
                        if (dx_id) {
                            var component = context.get_component_by_div_id(dx_id);
                            if (component && component.visual_control && component.visual_control.render) {
                                context.fix_visual_control_size($('#' + dx_id), $('#' + dx_id + '-title'), component.visual_control);
                            }
                        }
                    }
                }
            }
        }
        this.resizing = false;
    },
    componentDidUpdate: function () {
        //variable declarations
        var context = this,
            i,j,u,v,
            options = {
                animate: true,
                float: true,
                width: 12,
                cellHeight: 80,
                verticalMargin: 10,
                handle:'.grid-stack-item-content>*'
            },
            update_home_layout,
            home_grid = $('#home_grid'),
            gridstack,
            component,
            dp_width,
            dp_height,
            dp_x,
            dp_y,
            dp_loc,
            jquery_element,
            jquery_element_title,
            type,
            aggregation_data,
            value_field,
            data,
            label_format,
            argument_field,
            properties,
            pointclickevent,
            data_point,
            argument_name,
            unique_id;
        if (Object.keys(this.state.components).length == 0 || !this.state.home_layout || this.state.gridstack) {
            return;
        }
        update_home_layout = function () {
            var arr,
                node,
                dx_id,
                component,
                dashboard_part_id;

            if (context.state.gridstack) {
                arr = [];
                $('.grid-stack-item').each(function () {
                    node = $(this).data('_gridstack_node');
                    if (node == null) {
                        return;
                    }
                    dx_id = this.children[0].children[1].getAttribute('id');
                    if (dx_id) {
                        component = context.get_component_by_div_id(dx_id);
                        if (component == null) {
                            return;
                        }
                        dashboard_part_id = component.dashboard_part.code;
                        arr.push(
                            {
                                dashboard_part_id: dashboard_part_id,
                                x: node.x,
                                y: node.y,
                                width: node.width,
                                height: node.height
                            }
                        );
                    }
                });
                localStorage.removeItem('home');
                localStorage.removeItem('get_home_layout');
                invoke_method("user", "update_home_layout", arr);
            }
        };
        gridstack = home_grid.gridstack(options).data('gridstack');
        home_grid.on('dragstart', function () {
            context.noClick = true;
        });
        home_grid.on('dragstop', function () {
            update_home_layout();
        });
        home_grid.on('resizestop', function () {
            update_home_layout();
        });
        for (var key in this.state.components) {
            component = this.state.components[key];
            dp_width = component.dashboard_part.width;
            dp_height = component.dashboard_part.height;
            dp_x = component["row_number"];
            dp_y = component["col_number"];
            dp_loc = this.get_dashboard_part_loc(component.dashboard_part.code);
            if (dp_loc) {
                dp_width = dp_loc.width;
                dp_height = dp_loc.height;
                dp_x = dp_loc.x;
                dp_y = dp_loc.y;
            }
            var widgetBody = '' +
                '<div class="widget no-header dashboard-part">' +
                    '<div class="grid-stack-item-content widget-body">' +
                            '<div class="dashboard-part-title">' +
                                '<a id="' + component.div_id + '-title">' +
                                '</a>' +
                            '</div>' +
                            '<div id="' + component.div_id + '">' +
                            '</div>'+
                    '</div>' +
                '</div>';
            if (typeof dp_x != 'undefined' && typeof dp_y != 'undefined') {
                gridstack.addWidget(widgetBody, dp_x, dp_y, dp_width, dp_height, false);
            }
            else {
                gridstack.addWidget(widgetBody, 0, 0, dp_width, dp_height, true);
            }
            jquery_element = $("#" + component.div_id);
            jquery_element_title = $("#" + component.div_id + "-title");
            type = component.dashboard_part["visualization_type"];
            var description = component.dashboard_part["description"];
            aggregation_data = component.dashboard_part.aggregation_data || [];
            if ((aggregation_data && Array.isArray(aggregation_data) && (aggregation_data.length > 0)) || component.dashboard_part.display_empty_graph) {
                /*Auto translate everything that is translatable*/
                for (i = 0; i < aggregation_data.length; i++) {
                    value_field = component.dashboard_part.custom_properties.valueField;
                    data = aggregation_data[i][value_field];
                    /* We will try to migrate over to creating our own code instead of dev express,
                     * right now line and bar charts use dev express and tile and ranked lists use this.
                     */
                    label_format = component.dashboard_part.custom_properties.label_format;
                    if(label_format && (type == "ranked_list" || type == "tile")) {
                        switch(label_format) {
                            case "currency":
                                aggregation_data[i][value_field] = parseInt(aggregation_data[i][value_field]).toLocaleString();
                                if(navigator.language == 'en-US') { //Temporary until we decide how to use toLocaleString with an object as the curerncy type.
                                    aggregation_data[i][value_field] = '$' + aggregation_data[i][value_field];
                                }
                            break;
                            default:
                            break;
                        }
                    }
                    if (typeof data === "string" && R[data]) {
                        data = R[data];
                    }
                    argument_field = component.dashboard_part.custom_properties.argumentField;
                    if (typeof aggregation_data[i][argument_field] === "string" && R[aggregation_data[i][argument_field]]) {
                        aggregation_data[i][argument_field] = R[aggregation_data[i][argument_field]];
                    }
                }
                /*End of auto translate*/
                switch (type) {
                    case "pie_chart":
                        properties = {};
                        this.set_dashboard_item_title(jquery_element_title, component.dashboard_part.caption, component);
                        properties.dataSource = aggregation_data;
                        properties.legend = {visible: false};
                        properties.animation = {enabled: true};
                        properties.resolveLabelOverlapping = "shift";
                        pointclickevent = function(current_linked_app,properties,aggregationdata){
                            properties.onPointClick = function(e){
                                var app_object = {};
                                app_object.type = "data_list";
                                app_object.code = current_linked_app;
                                var elementPos = aggregationdata.map(function(x) {return x._id; }).indexOf(e.target.argument);
                                app_object.conditions = aggregationdata[elementPos].conditions;
                                return context.props.app_object_handler(app_object);
                            }
                        }(component.dashboard_part.linked_app_object_code,properties,aggregation_data);
                        properties.series = [{
                            argumentField: component.dashboard_part.custom_properties.argumentField,
                            valueField: component.dashboard_part.custom_properties.valueField,
                            label: {
                                visible: true,
                                customizeText: function (arg) {
                                    return arg.argumentText + " (" + arg.valueText + ")";
                                }
                            }
                        }];

                        label_format = component.dashboard_part.custom_properties['label_format'];
                        if(label_format) {
                            properties.commonAxisSettings = {
                                label: {
                                    format: {
                                        type: label_format,
                                        precision: 2
                                    }
                                }
                            };
                        }
                        jquery_element.dxPieChart(properties);
                        component.visual_control = jquery_element.dxPieChart("instance");
                        this.fix_visual_control_size(jquery_element, jquery_element_title, component.visual_control);
                        break;
                    case "line_chart":
                        properties = {};
                        this.set_dashboard_item_title(jquery_element_title, component.dashboard_part.caption, component);
                        properties.dataSource = aggregation_data;
                        properties.legend = {
                            verticalAlignment: "bottom",
                            horizontalAlignment: "center",
                            itemTextPosition: "bottom"
                        };
                        properties.animation = {enabled: true};
                        properties.resolveLabelOverlapping = "shift";
                        pointclickevent = function(current_linked_app,properties,aggregationdata){
                            properties.onPointClick = function(e){
                                var app_object = {};
                                app_object.type = "data_list";
                                app_object.code = current_linked_app;
                                var condition = aggregationdata;
                                var argumentField = e.target.series.getArgumentField();
                                var elementPos = condition.map(function(x) {return x[argumentField];}).indexOf(e.target.argument);
                                var conditions = e.target.series.conditionField;
                                conditions = conditions?conditions:e.target.series.name.replace(/ /g,'') + 'Conditions';
                                app_object.conditions = aggregationdata[elementPos][conditions];
                                return context.props.app_object_handler(app_object);
                            }
                        }(component.dashboard_part.linked_app_object_code,properties,aggregation_data);

                        if (aggregation_data[0] && aggregation_data[0].series && aggregation_data[0].series.length){
                            properties.series = aggregation_data[0].series;
                            for (j = 0, v = properties.series.length; j<v;j++){
                                properties.series[j].valueField = properties.series[j].name.replace(/ /g,'');
                                properties.series[j].conditionField = properties.series[j].name.replace(/ /g,'') + 'Conditions';
                                for (i = 0, u = aggregation_data.length; i<u;i++){
                                    aggregation_data[i][properties.series[j].valueField] = aggregation_data[i].series[j]['fieldValue'];
                                    aggregation_data[i][properties.series[j].conditionField] = aggregation_data[i].series[j].conditions;
                                }
                            }
                            properties.dataSource = aggregation_data;
                        }
                        else{
                            if (component.dashboard_part.custom_properties.series){
                                properties.series = component.dashboard_part.custom_properties.series;
                            }
                            else{
                                properties.series = [{
                                    argumentField: component.dashboard_part.custom_properties.argumentField,
                                    valueField: component.dashboard_part.custom_properties.valueField,
                                    name: component.dashboard_part.custom_properties.name_caption,
                                    color: component.dashboard_part.custom_properties.color
                                }];
                            }
                        }
                        argument_field = component.dashboard_part.custom_properties.argumentField;
                        if (!argument_field){argument_field = "_id"}
                        properties.commonSeriesSettings = {
                            argumentField:  argument_field,
                            type: "line",
                            hoverMode: "allArgumentPoints",
                            selectionMode: "allArgumentPoints"
                        };

                        label_format = component.dashboard_part.custom_properties.label_format;
                        if(label_format) {
                            properties.commonAxisSettings = {
                                label: {
                                    format: {
                                        type: label_format,
                                        precision: 2
                                    }
                                }
                            };
                        }
                        properties.tooltip = {
                            enabled:true,
                            customizeTooltip:function(point_info){
                                return {
                                    text:point_info.argumentText
                                }
                            }
                        };
                        jquery_element.dxChart(properties);
                        component.visual_control = jquery_element.dxChart("instance");
                        this.fix_visual_control_size(jquery_element, jquery_element_title, component.visual_control);
                        break;
                    case "bar_chart":
                        properties = {};
                        this.set_dashboard_item_title(jquery_element_title, component.dashboard_part.caption, component);
                        properties.dataSource = aggregation_data;
                        properties.animation = {enabled: true};
                        pointclickevent = function(current_linked_app,properties, local_dashboard_part){
                            properties.onPointClick = function(e){
                                var app_object = {};
                                app_object.type = "data_list";
                                app_object.code = current_linked_app;
                                var aggregationdata = local_dashboard_part.aggregation_data;
                                var condition = aggregationdata;
                                var argumentField = e.target.series.getArgumentField();
                                var dashboard_series = (properties.series) ? properties.series[e.target.series.index] : null;
                                var elementPos = condition.map(function(x) {return x[argumentField];}).indexOf(e.target.argument);
                                var conditions = e.target.series.conditionField;
                                conditions = conditions?conditions:e.target.series.name.replace(/ /g,'') + 'Conditions';
                                app_object.conditions = aggregationdata[elementPos][conditions];
                                app_object.conditions = app_object.conditions || aggregationdata[elementPos]['conditions'];
                                if(dashboard_series && dashboard_series.added_drilldown_conditions) {
                                    try {
                                        var added_drilldown_conditions;
                                        added_drilldown_conditions = JSON.parse(dashboard_series.added_drilldown_conditions);
                                        if(added_drilldown_conditions) {
                                            if(app_object.conditions) {
                                                app_object.conditions = $.extend(true, {}, app_object.conditions);
                                            }
                                            else {
                                                app_object.conditions = {};
                                            }
                                            if(app_object.conditions.$and) {
                                                app_object.conditions.$and.push(added_drilldown_conditions);
                                            }
                                            else {
                                                $.extend(app_object.conditions, added_drilldown_conditions);
                                            }
                                        }
                                    }
                                    catch (ex) {

                                    }
                                }
                                return context.props.app_object_handler(app_object);
                            }
                        }(component.dashboard_part.linked_app_object_code,properties,component.dashboard_part);
                        if (aggregation_data[0] && aggregation_data[0].series && aggregation_data[0].series.length){
                            properties.series = aggregation_data[0].series;
                            for (j = 0, v = properties.series.length; j<v;j++){
                                properties.series[j].valueField = properties.series[j].name.replace(/ /g,'');
                                properties.series[j].conditionField = properties.series[j].name.replace(/ /g,'') + 'Conditions';
                                for (i = 0, u = aggregation_data.length; i<u;i++){
                                    aggregation_data[i][properties.series[j].valueField] = aggregation_data[i].series[j].fieldValue;
                                    aggregation_data[i][properties.series[j].conditionField] = aggregation_data[i].series[j].conditions;
                                }
                            }
                            properties.dataSource = aggregation_data;
                        }
                        else{
                            if (component.dashboard_part.custom_properties.series){
                                properties.series = component.dashboard_part.custom_properties.series;
                            }
                            else{
                                properties.series = [{
                                    argumentField: component.dashboard_part.custom_properties.argumentField,
                                    valueField: component.dashboard_part.custom_properties.valueField,
                                    name: component.dashboard_part.custom_properties.name_caption,
                                    color: component.dashboard_part.custom_properties.color,
                                    axis: component.dashboard_part.custom_properties.axis,
                                    type: component.dashboard_part.custom_properties.type,
                                    label: component.dashboard_part.custom_properties.label
                                }];
                            }
                        }
                        var argumentField = component.dashboard_part.custom_properties.argumentField;
                        if (!argumentField){argumentField = "_id"}
                        properties.commonSeriesSettings = {
                            argumentField:  argumentField,
                                type: ((component.dashboard_part.custom_properties.visualization_sub_type) ? component.dashboard_part.custom_properties.visualization_sub_type : "bar")
                        };
                        properties.valueAxis = component.dashboard_part.custom_properties.valueAxis;
                        /*Implement in the near future
                        properties.tooltip = {
                            enabled: true
                        };
                        */
                        label_format = component.dashboard_part.custom_properties.label_format;
                        if(label_format) {
                            properties.commonAxisSettings = {
                                label: {
                                    format: {
                                        type: label_format,
                                        precision: 2
                                    }
                                }
                            };
                        }
                        if(component.dashboard_part.custom_properties.rotated) {
                            properties.rotated = true;
                        }
                        jquery_element.dxChart(properties);
                        component.visual_control = jquery_element.dxChart("instance");
                        this.fix_visual_control_size(jquery_element, jquery_element_title, component.visual_control);
                        break;
                    case "vector_map":
                        this.set_dashboard_item_title(jquery_element_title, component.dashboard_part.caption, component);
                        properties = {};
                        var dxProperties = component.dashboard_part.custom_properties.dx_properties,
                            mapSource = "",
                            bounds = "",
                            centermap = [0,0],
                            zoomfactor = 1,
                            dataPoints = convert_to_dictionary_by_field_names(aggregation_data, {key: "_id", value: "value"});
                        if(dxProperties.layers.dataSource == "DevExpress.viz.map.sources.usa"){
                            mapSource = DevExpress.viz.map.sources.usa;
                            bounds = [-160, 70, -65,20];
                            centermap = [-100, 38];
                            zoomfactor = 2.5;
                        }
                        else{
                            mapSource = DevExpress.viz.map.sources.world;
                            bounds = [-180, 85, 180, -60];
                        }
                        properties.layers = {
                                name: dxProperties.layers.name,
                                dataSource: mapSource,
                                palette: dxProperties.layers.palette,
                                colorGroups: dxProperties.layers.colorGroups,
                                colorGroupingField: dxProperties.layers.colorGroupingField,
                                label: dxProperties.layers.label,
                            customize: function (elements) {
                                $.each(elements, function (_, element) {
                                    var Data = dataPoints[element.attribute("name")];
                                    element.attribute("count", Data && Data.count || 0);
                                });
                            }
                        };
                        properties.legends =  [{
                            source: dxProperties.legends[0].source,
                            customizeText: function (arg) {
                                return format(arg.start) + " to " + format(arg.end);
                            }
                        }];
                        properties.bounds = bounds;
                        properties.zoomFactor= zoomfactor;
                        properties.center = centermap;
                        properties.redrawOnResize=true;
                        pointclickevent = function(current_linked_app,properties,aggregationdata){
                            properties.onClick = function(e){
                                var app_object = {};
                                app_object.type = "data_list";
                                app_object.code = current_linked_app;
                                var conditions = find_by_field('_id', e.target.attribute('name'), aggregationdata);
                                if (conditions){
                                    app_object.conditions = conditions.conditions;
                                }
                                return context.props.app_object_handler(app_object);
                            };
                        }(component.dashboard_part.linked_app_object_code,properties,aggregation_data);
                        jquery_element.dxVectorMap(properties);
                        component.visual_control = jquery_element.dxVectorMap("instance");
                        break;
                    case "ranked_list":
                        value_field = component.dashboard_part.custom_properties.valueField;
                        argument_field = component.dashboard_part.custom_properties.argumentField;
                        this.set_dashboard_item_title(jquery_element_title, component.dashboard_part.custom_properties.name_caption, component);
                        var thead = '<thead>';
                        thead += '<tr>';
                        thead += '<th>';
                        thead += component.dashboard_part.custom_properties.argument_field_caption;
                        thead += '</th>';
                        thead += '<th style="text-align: right;">';
                        thead += component.dashboard_part.custom_properties.value_field_caption;
                        thead += '</th>';
                        thead += '</tr>';
                        thead += '</thead>';
                        var tbody = '<tbody>';
                        for (i = 0; i < aggregation_data.length; i++) {
                            data_point = aggregation_data[i][value_field];
                            argument_name = aggregation_data[i][argument_field];
                            unique_id = aggregation_data[i]._id.replace(/[ &,./]/g,'') + component.div_id+i;

                            tbody += '<tr><td style="text-align: left;"><div style="text-decoration: underline;cursor: pointer;" id="'+unique_id+'">' + argument_name + '</div></td><td style="text-align: right;">' + data_point + '</td></tr>';
                        }
                        tbody += '</tbody>';
                        var html = "<table style='width:100%' class='table table-striped'>";
                        html += thead;
                        html += tbody;
                        html += "</table>";
                        jquery_element.html(html);
                        for (i = 0; i < aggregation_data.length; i++) {
                            unique_id = aggregation_data[i]._id.replace(/[ &,./]/g,'') + component.div_id+i;
                            pointclickevent = function(current_linked_app,aggregationdata,unique_id){

                                $('#'+unique_id).bind( "click", function() {

                                    var app_object = {};
                                    app_object.type = "data_list";
                                    app_object.code = current_linked_app;
                                    app_object.conditions = aggregationdata.conditions;
                                    return context.props.app_object_handler(app_object);
                                });

                            }(component.dashboard_part.linked_app_object_code,aggregation_data[i],unique_id)
                        }
                        break;
                    case "tile":
                        value_field = component.dashboard_part.custom_properties.valueField;
                        data_point = aggregation_data[0][value_field];

                        argument_field = component.dashboard_part.custom_properties.argumentField;
                        argument_name = aggregation_data[0][argument_field];

                        this.set_dashboard_item_title(jquery_element_title, argument_name, component, description);

                        var data_point_color;
                        if (component.dashboard_part.custom_properties && component.dashboard_part.custom_properties.data_point_color) {
                            data_point_color = component.dashboard_part.custom_properties.data_point_color;
                        }
                        else {
                            data_point_color = "black";
                        }
                        var fontSize = 4;
                        if (data_point.toString().length <= 6) {
                            fontSize = (12 - data_point.toString().length);
                        } else if (data_point.toString().length <= 8) {
                            fontSize = 6;
                        }
                        else if (data_point.toString().length <= 10) {
                            fontSize = 5;
                        }
                        var tile_html = "<div class=''>";
                        unique_id = aggregation_data[0]._id.replace(/ /g,'').replace(/&/g,'').replace(/,/g,'').replace(/./g,'') + component.div_id;
                        tile_html += "<div id="+unique_id+">";
                        tile_html += "<div class='bg-white no-padding'>";
                        tile_html += "<h1 style='color:" + data_point_color + ";font-size: " + fontSize + "vw' class='dashboard-part-tile-body'>" + data_point + "</h1>";

                        tile_html += "</div></div></div>";

                        jquery_element.html(tile_html);
                        pointclickevent = function(current_linked_app,aggregationdata,unique_id){
                            $('#'+unique_id).bind( "click", function() {
                                if(context.noClick)
                                {
                                    context.noClick = false;
                                }
                                else{
                                    var app_object = {};
                                    app_object.type = "data_list";
                                    app_object.code = current_linked_app;
                                    app_object.conditions = aggregationdata.conditions;
                                    return context.props.app_object_handler(app_object);
                                }


                            });

                        }(component.dashboard_part.linked_app_object_code,aggregation_data[0],unique_id)
                        break;
                    default:
                        break;
                }
            }
            else
            {
                this.set_dashboard_item_title(jquery_element_title, component.dashboard_part.caption, component);
                var noDataElement = $('<span class="dx-datagrid-nodata">' + R.no_data + '</span>');
                jquery_element.append(noDataElement);
                noDataElement.css({
                    marginTop: -Math.floor(noDataElement.height() / 2),
                    marginLeft: -Math.floor(noDataElement.width() / 2)
                });
            }
        }
        this.setState({gridstack:gridstack});
        $(window).trigger('resize');
    },
    refresh_dashboard_part_data_with_options: function(local_component) {
        if (local_component.visual_control) { //This requires display_empty_graph to be true for the dashbo
            var error = function (err) {
                server_error_action(err);
            };
            var db_part_success = function (local_data) {
                local_component.dashboard_part.aggregation_data = local_data;
                local_component.visual_control.option("dataSource", local_data);
            };
            invoke_method("aggregation", "get_aggregation_data",
                {
                    aggregation_code: local_component.dashboard_part.aggregation_code,
                    options: local_component.dashboard_part.options_data
                }, db_part_success, error);
        }
    },
    initialize_dashboard: function () {
        var context = this;
        var get_dashboard_parts = function () {
            var error = function (err) {
                server_error_action(err);
            };

            var success = function (data) {
                localStorage.setItem("home", JSON.stringify(data));
                //Scoping the variables high enough to grant access to components and reduce redefining div_id multiple times
                var app_object = data.app_object;
                if(app_object.code && (app_object.code != "home")) {
                    return context.props.app_object_handler(app_object, true);
                }
                var components = {};
                var num_db_part_requests_resolved = 0;
                var dashboard_parts_length = data.app_object.dashboard_parts.length;

                var add_db_part_with_data_to_components = function(dashboard_part) {
                    var div_id = create_uid();
                    components[dashboard_part.code] = {};
                    components[dashboard_part.code].div_id = div_id;
                    components[dashboard_part.code].dashboard_part = dashboard_part;
                };

                var get_db_part_data = function (iteration){
                    var db_part_success = function (local_data) {
                        data.app_object.dashboard_parts[iteration].aggregation_data = local_data;
                        add_db_part_with_data_to_components(data.app_object.dashboard_parts[iteration]);
                    };
                    var complete = function(){
                        num_db_part_requests_resolved++;
                        if (num_db_part_requests_resolved >= dashboard_parts_length){
                            context.setState({app_object: app_object, components: components});
                            context.props.handle_executing(false);
                        }
                    };
                    invoke_method("aggregation", "get_aggregation_data",
                        {
                            aggregation_code: (data.app_object.dashboard_parts[iteration] || {}).aggregation_code
                        }, db_part_success, error, complete);
                };
                if(dashboard_parts_length) {
                    for (var i = 0; i < dashboard_parts_length; i++) {
                        get_db_part_data(i); //sends off a separate request for each dashboard_part
                    }
                }else {
                    context.props.handle_executing(false);
                }
                push_href_location(data.app_object.name + " - " + (R.client_application_title || "Xenforma"), "/");
            };

            if (localStorage.getItem("home") === null || localStorage.getItem("home") =="" || localStorage.getItem("home") === undefined) {
                get_app_object("home", {}, success, error);
            }
            else {
                var storage_data = localStorage.getItem("home");
                storage_data = JSON.parse(storage_data);
                success(storage_data);
            }
        };

        var get_home_layout = function () {

            var success = function (data) {
                data = data.data;
                localStorage.setItem("get_home_layout", JSON.stringify(data));
                context.setState({home_layout: data});
            };

            var error = function (err) {
                context.props.navigation_handler("logout");
                context.props.logged_in_false(err.message);
            };

            if (localStorage.getItem("get_home_layout") === null || localStorage.getItem("get_home_layout") == "" || localStorage.getItem("get_home_layout") === undefined) {
                invoke_method("user", "get_home_layout", {}, success, error);
            }
            else {
                var data = localStorage.getItem("get_home_layout");
                data = JSON.parse(data);
                setTimeout(function () {
                    context.setState({home_layout: data});
                }, 10);

            }
        };

        get_home_layout();
        get_dashboard_parts();
    },
    render: function () {

        var error_component = "";
        if (this.state.error) {
            error_component =
                <div><ErrorNotificationComponent message={this.state.error} on_close={this.on_error_close}/><br /></div>

        }

        return (
            <div className="form-group">
                {error_component}
                <div id="home_grid" className="grid-stack"></div>
            </div>

        );
    }
});
